import React, { useState } from 'react';
import styled from 'styled-components';
import FindAPlanCards from '../../components/LandingPageComponents/FindAPlanCards/FindAPlanCards';
import SmartBrands from '../../components/LandingPageComponents/SmartBrands/SmartBrands';
import LandingHeader from '../../components/LandingPageComponents/LandingHeader/LandingHeader';
import LandingFooter from '../../components/LandingPageComponents/LandingFooter/LandingFooter';
import BookDemoPopup from '../LandingPage/partials/BookDemoPopup';
import { Helmet } from 'react-helmet-async';
const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
  overflow-y: scroll;
  background: radial-gradient(
    95.86% 126.4% at 0% 5.38%,
    rgba(226, 243, 187, 0.7) 0%,
    rgba(157, 200, 187, 0.7) 100%
  );
  height: 100vh; /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */

  @media only screen and (max-width: 768px) {
    max-height: ${(props) => (props.menuOpen ? '100vh' : 'unset')};
  }
`;
const HeaderWrapper = styled.div`
  // position: fixed;
  width: 100%;
  top: 0;
  z-index: 9;
  @media only screen and (max-width: 768px) {
    position: unset;
    display: flex;
    justify-content: center;
  }
`;
const Pricing = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Helmet>
        <title>BrandAstra | Free AI Marketing & Brand Intelligence Tool</title>
        <meta name="description" content="Explore BrandAstra's flexible pricing plans with a free 15-day trial. Choose from Standard, Pro, Scale, and Elite plans designed to fit businesses of all sizes. Access AI-driven brand insights, real-time sentiment analysis, competitive intelligence, and scalable solutions to accelerate decisions and drive growth." />
        <meta name="keywords" content="BrandAstra, social listening, AI insights" />
        <link rel="canonical" href="https://brandastra.ai/pricing" />
      </Helmet>
      <Wrapper menuOpen={menuOpen}>
        <HeaderWrapper>
          <LandingHeader
            setMenuOpen={(data) => {
              setMenuOpen(data);
            }}
            setPopupOpen={(data) => setIsOpen(data)}
          />
        </HeaderWrapper>
        <FindAPlanCards setPopupOpen={(data) => setIsOpen(data)} />
        <SmartBrands setPopupOpen={(data) => setIsOpen(data)} />
        <BookDemoPopup isOpen={isOpen} setIsOpen={(data) => setIsOpen(data)} />
        <LandingFooter
          bgColor={'linear-gradient(99.96deg, #063257 0.95%, #006867 99.05%)'}
        />
      </Wrapper>
    </>

  );
};
export default Pricing;
